export type { AvatarProps } from './Avatar'
export { Avatar } from './Avatar'
